import { CoursesIcon } from '@h2/components/icons/courses'
import { ReportingIcon } from '@h2/components/icons/reporting'
import { ClusterIcon } from '@h2/components/icons/cluster'
import { NotesIcon } from '@h2/components/icons/notes'
import { RecommendationIcon } from '@h2/components/icons/recommendation'
import { ListIcon } from '@h2/components/icons/list'
import { CategoryIcon } from '@h2/components/icons/category'
import { SelfAssessmentIcon } from '@h2/components/icons/selfAssessment'
import { InterestProfilerIcon } from '@h2/components/icons/interestProfiler'
import { BudgetYourLifeProfilerIcon } from '@h2/components/icons/budgetYourLifeProfiler'
import { WorkImportanceProfilerIcon } from '@h2/components/icons/workImportanceProfiler'
import { SkillsProfilerIcon } from '@h2/components/icons/skillsProfiler'
import { ResumeIcon } from '@h2/components/icons/resume'
import { CoverLetterIcon } from '@h2/components/icons/coverLetter'
import { ReferenceListIcon } from '@h2/components/icons/referenceList'
import { PlanIcon } from '@h2/components/icons/plan'
import { VideoIcon } from '@h2/components/icons/video'
import { OccupationsIcon } from '@h2/components/icons/occupations'
import { BudgetSpyglassIcon } from '@h2/components/icons/budgetSpyglass'
import { FinancialAidIcon } from '@h2/components/icons/financialAid'
import { JobsIcon } from '@h2/components/icons/jobs'
import { CollegeIcon } from '@h2/components/icons/college'
import { NetworkIcon } from '@h2/components/icons/network'
import { GroupsIcon } from '@h2/components/icons/groups'
import { LessonPlanIcon } from '@h2/components/icons/lessonPlan'
import { IndustryIcon } from '@h2/components/icons/industry'
import { MajorIcon } from '@h2/components/icons/major'
import { ResourcesIcon } from '@h2/components/icons/resources'
import { UtlIcon } from '@h2/components/icons/utl'
import { SkillsDecoderIcon } from '@h2/components/icons/skillsDecoder'
import { WorkKeysIcon } from '@h2/components/icons/workKeys'
import { SupplyDemandIcon } from '@h2/components/icons/supplyDemand'
import { CollegePrefProfilerIcon } from '@h2/components/icons/collegePrefProfiler'

const icons = {
  usageSummaryReport: ReportingIcon,
  searchTermReport: ReportingIcon,
  industriesViewedReport: ReportingIcon,
  majorsViewedReport: ReportingIcon,
  collegesViewedReport: ReportingIcon,
  occupationsViewedReport: ReportingIcon,
  schoolUsageReport: ReportingIcon,
  adminCreationReport: ReportingIcon,
  adminVotingManagement: undefined,
  manageResources: ResourcesIcon,
  manageSurveys: LessonPlanIcon,
  manageLocalOpportunities: NetworkIcon,
  manageLessons: LessonPlanIcon,
  manageUsers: GroupsIcon,
  upTheLadder: UtlIcon,
  additionalResources: ResourcesIcon,
  findEducationTraining: MajorIcon,
  findCollege: CollegeIcon,
  typeOfField: MajorIcon,
  localJobSearch: JobsIcon,
  choosingIndustry: IndustryIcon,
  choosingFieldOfStudy: MajorIcon,
  clusters: ClusterIcon,
  financialAid: FinancialAidIcon,
  costOfCollege: BudgetSpyglassIcon,
  allOccupations: OccupationsIcon,
  videoLibrary: VideoIcon,
  actionPlan: PlanIcon,
  coursePlanning: CoursesIcon,
  referenceListBuilder: ReferenceListIcon,
  letterBuilder: CoverLetterIcon,
  resumeBuilder: ResumeIcon,
  skillsProfiler: SkillsProfilerIcon,
  skillsAssessment: SkillsDecoderIcon,
  workImportanceProfiler: WorkImportanceProfilerIcon,
  budgetYourLife: BudgetYourLifeProfilerIcon,
  interestProfiler: InterestProfilerIcon,
  quickAssessment: SelfAssessmentIcon,
  myFiles: CategoryIcon,
  assignments: ListIcon,
  bookmarksAndRatings: RecommendationIcon,
  journal: NotesIcon,
  explorationClusterReport: ClusterIcon,
  portfolioSummaryReport: ReportingIcon,
  workKeys: WorkKeysIcon,
  collegePreferences: CollegePrefProfilerIcon,
  supplyDemandReport: SupplyDemandIcon
}

export { icons }
